import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      options={{
        background: {
          color: { value: "transparent" },
        },
        fullScreen: { enable: false },
        fpsLimit: 60,
        particles: {
          number: {
            value: 8,
            density: {
              enable: true,
              area: 800,
            },
          },
          color: {
            value: ["#38bdf8", "#0ea5e9", "#67e8f9"], // Tailwind sky shades
          },
          shape: {
            type: "circle",
          },
          opacity: {
            value: 0.03,
          },
          size: {
            value: { min: 80, max: 200 },
          },
          move: {
            enable: true,
            speed: 0.3,
            direction: "none",
            random: true,
            straight: false,
            outModes: "out",
          },
        },
        interactivity: {
          detectsOn: "canvas",
          events: {
            onHover: { enable: false },
            onClick: { enable: false },
            resize: true,
          },
        },
        detectRetina: true,
      }}
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none", // ensures it's purely visual
      }}
    />
  );
}

export default Particle;